import type { RouteRecordRaw } from "vue-router";
const onError = (err: any) => {
  console.error("Failed to load async component: ", err);
  throw new Error(err);
};

const OfferNew: RouteRecordRaw = {
  name: "Offer管理(NEW)",
  path: "/offerNew",
  component: () => import("@/components/Layout/index.vue").catch(onError),
  meta: {
    key: "/offerNew"
  },
  children: [
    {
      name: "Offer列表(NEW)",
      path: "offer-list-new",
      meta: {
        key: "/offerNew/offer-list-new",
        keepAlive: true
      },
      component: () =>
        import("@/views/OfferNew/OfferList/index.vue").catch(onError)
    }
  ]
};

export default OfferNew;
